
export default function TechnologyPartners() {
  return (
    <section className="bg-[#F7F5F2] py-24">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h3 className="font-serif text-3xl md:text-4xl text-[#0E1A2B] mb-4">
            Built on enterprise-grade infrastructure
          </h3>
          <p className="text-lg text-[#8A8F98] max-w-2xl mx-auto">
            Our systems integrate with the tools law firms already trust
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="bg-white p-8 border border-[#8A8F98]/20 flex items-center justify-center h-32">
            <div className="text-center">
              <i className="ri-database-2-line text-4xl text-[#0E1A2B] mb-2"></i>
              <p className="text-[#8A8F98] text-xs font-medium">Secure Database Systems</p>
            </div>
          </div>
          <div className="bg-white p-8 border border-[#8A8F98]/20 flex items-center justify-center h-32">
            <div className="text-center">
              <i className="ri-cloud-line text-4xl text-[#0E1A2B] mb-2"></i>
              <p className="text-[#8A8F98] text-xs font-medium">Cloud Infrastructure</p>
            </div>
          </div>
          <div className="bg-white p-8 border border-[#8A8F98]/20 flex items-center justify-center h-32">
            <div className="text-center">
              <i className="ri-phone-line text-4xl text-[#0E1A2B] mb-2"></i>
              <p className="text-[#8A8F98] text-xs font-medium">Communication Platforms</p>
            </div>
          </div>
          <div className="bg-white p-8 border border-[#8A8F98]/20 flex items-center justify-center h-32">
            <div className="text-center">
              <i className="ri-file-text-line text-4xl text-[#0E1A2B] mb-2"></i>
              <p className="text-[#8A8F98] text-xs font-medium">Document Management</p>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-[#0E1A2B] p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-4xl text-[#C8A14A]"></i>
              </div>
              <h4 className="text-[#F7F5F2] font-semibold mb-2">Rapid Deployment</h4>
              <p className="text-[#8A8F98] text-sm">Systems operational within weeks, not months</p>
            </div>
            <div>
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-4xl text-[#C8A14A]"></i>
              </div>
              <h4 className="text-[#F7F5F2] font-semibold mb-2">Dedicated Support</h4>
              <p className="text-[#8A8F98] text-sm">Direct access to technical and strategic advisors</p>
            </div>
            <div>
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-4xl text-[#C8A14A]"></i>
              </div>
              <h4 className="text-[#F7F5F2] font-semibold mb-2">Continuous Optimization</h4>
              <p className="text-[#8A8F98] text-sm">Performance monitoring and system refinement</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
